import { HTTP as http } from "../../http";

const PREFIX = "/category";

export default {
    getListProducts: data => {
        return http.post(PREFIX + "/getListProducts", data);
    }
};
